import React from 'react';
import MarketStateFilterInput from '@app/model/market_state/input/MarketStateFilterInput';
import MenuButtonFilter from '@app/component/menu/MenuButtonFilter';
import {
	useMarketStateFilterInputTools
} from '@app/site/secured/rateshopper/rates/provider/useMarketStateFilterInputTools';
import CompanyHotelDashboardFilter from '@app/model/company_hotel/settings/CompanyHotelDashboardFilter';

type DashboardSelectGuestsFilterProps = {
	filter: MarketStateFilterInput,
	onFilter: (filter: MarketStateFilterInput) => void
}

const DashboardSelectGuestsFilter = React.memo(
	function DashboardSelectGuestsFilterFragment({ filter, onFilter }: DashboardSelectGuestsFilterProps) {
		const {isDashboardFilterEnabled} = useMarketStateFilterInputTools()
		const providerSupportsFilter = isDashboardFilterEnabled(CompanyHotelDashboardFilter.GUESTS);

		const menuItems = [
			{ name: '1+ Guest', value: 1 },
			{ name: '2+ Guests', value: 2 },
			{ name: '3+ Guests', value: 3 },
			{ name: '4+ Guests', value: 4 },
			{ name: '5+ Guests', value: 5 },
			{ name: '6+ Guests', value: 6 },
			{ name: '7+ Guests', value: 7 },
			{ name: '8+ Guests', value: 8 },
		];

		const onSelect = (value: number) => {
			onFilter({
				...filter,
				guests: value,
			});
		};

		return <MenuButtonFilter menuItems={menuItems}
														 selectedValue={filter.guests}
														 onSelect={onSelect}
														 disabled={!providerSupportsFilter}
														 menuDescription="Please select the minimum occupancy your wish to compare." />;
	});


export default DashboardSelectGuestsFilter;